import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { Box, Flex } from '../../units/Box/Box';

import FORMS from '../../../store/forms/formsConfigs/constants';
import FormsActions from '../../../store/forms/formsActions';
import FormsSelectors from '../../../store/forms/utils/formsSelectors';

import RegistrationStepForm from './RegistrationStepForm/RegistrationStepForm';
import RegistrationSteps from './RegistrationSteps/RegistrationSteps';

import { steps, registerFormsIds, getFormStepById } from './config';

class NewClient extends Component {
  static propTypes = {
    form: PropTypes.object
  };

  static defaultProps = {
    form: null
  };

  state = {
    activeStep: 0
  };

  componentWillReceiveProps = nextProps => {
    this.setCurrentRegistrationStep(nextProps);
  };

  componentWillMount() {
    FormsActions.initById({ id: FORMS.REGISTRAR_USER });
  }

  setCurrentRegistrationStep = nextProps => {
    if (!nextProps.form) return null;

    const activeStep = getFormStepById(nextProps.form.id);

    if (activeStep !== this.state.step) {
      this.setState({ activeStep });
    }

    return true;
  };

  render() {
    const { form } = this.props;

    return (
      <Box>
        <Flex justify="center">
          <RegistrationSteps steps={steps} activeStep={this.state.activeStep} />
        </Flex>

        <Box mt="60px">
          <RegistrationStepForm form={form} />
        </Box>
      </Box>
    );
  }
}

const getRegistrationForm = createSelector(
  FormsSelectors.getInPlaceForms,
  forms => {
    if (!forms) return null;

    const actionRegistrationForms = forms.filter(form =>
      registerFormsIds.includes(form.id)
    );

    return actionRegistrationForms[actionRegistrationForms.length - 1];
  }
);

export default connect(state => {
  return {
    form: getRegistrationForm(state)
  };
})(NewClient);



// WEBPACK FOOTER //
// ./src/components/containers/NewClient/NewClient.js